import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { ImpactJwtUser } from './useImpactJwt.interface';
import fetchImpactJwt from './useImpactJwt.request';

export default function useImpactJwt(
    user: ImpactJwtUser | undefined,
    options?: Omit<UseQueryOptions<string | null, AxiosError>, 'queryKey' | 'queryFn'>
) {
    return useQuery<string | null, AxiosError>({
        queryKey: ['impact', 'useImpactJwt', user],
        queryFn: async () => {
            const jwt = await fetchImpactJwt(user!);

            // The Advocate widget loader reads the token off window when the embed element upgrades.
            if (jwt) {
                window.impactToken = jwt;
                window.squatchToken = jwt;
            }

            return jwt;
        },
        staleTime: 1000 * 60 * 5,
        refetchOnWindowFocus: false,
        retry: false,
        ...options,
        enabled: !!user?.email && (options?.enabled ?? true),
    });
}
